// Traduções para português brasileiro

export const translateStatus = (status: string): string => {
  const statusTranslations: Record<string, string> = {
    // Campaign Status
    'ACTIVE': 'Ativa',
    'DRAFT': 'Rascunho',
    'COMPLETED': 'Concluída',
    'CANCELLED': 'Cancelada',
    
    // Coupon Status  
    'USED': 'Utilizado',
    'INVALID': 'Inválido',
    
    // Draw Status
    'PENDING': 'Pendente',
    'IN_PROGRESS': 'Em Andamento',
    
    // User Roles
    'ASSOCIACAO': 'Associação',
    'USUARIO_FINAL': 'Usuário Final',
  };

  return statusTranslations[status] || status;
};

export const getStatusColor = (status: string): 'success' | 'warning' | 'error' | 'info' | 'default' => {
  const statusColors: Record<string, 'success' | 'warning' | 'error' | 'info' | 'default'> = {
    'ACTIVE': 'success',
    'ATIVA': 'success',
    'COMPLETED': 'info',
    'CONCLUÍDA': 'info',
    'DRAFT': 'warning',
    'RASCUNHO': 'warning',
    'CANCELLED': 'error',
    'CANCELADA': 'error',
    'USED': 'success',
    'UTILIZADO': 'success',
    'INVALID': 'error',
    'INVÁLIDO': 'error',
    'PENDING': 'warning',
    'PENDENTE': 'warning',
    'IN_PROGRESS': 'info',
    'EM_ANDAMENTO': 'info',
  };

  return statusColors[status.toUpperCase()] || 'default';
}; 